import { bind } from '@react-rxjs/core'
import { createSignal } from '@react-rxjs/utils'
import { filter, map, switchMap, tap } from 'rxjs'
import { RegistrationData, RegistrationPrivateLabelPractitionerUserMetadata } from '../types'
import { isNotNull } from './filter'
import { registrationRequest } from './signup'
import { setRegistrationSuccess } from './success'

const [privateLabelPractitionerRegistrationInput$, setPrivateLabelPractitionerRegistrationInput] =
  createSignal<{
    input: RegistrationData & RegistrationPrivateLabelPractitionerUserMetadata
  }>()

// create hook for sharing latest input pending subscription to request observable
const [
  useLatestPrivateLabelPractitionerRegistrationInput,
  latestPrivateLabelPractitionerRegistrationInput$,
] = bind(privateLabelPractitionerRegistrationInput$, null)

export {
  setPrivateLabelPractitionerRegistrationInput,
  useLatestPrivateLabelPractitionerRegistrationInput,
}

export const privateLabelPractitionerRegistrationRequest$ =
  latestPrivateLabelPractitionerRegistrationInput$.pipe(
    filter(isNotNull),
    switchMap(({ input }) =>
      registrationRequest({ input, isGuestCheckoutEnabled: false }).pipe(
        map((response) => ({ input, response })),
        tap(setRegistrationSuccess)
      )
    )
  )
